import { render, staticRenderFns } from "./UserPositions.vue?vue&type=template&id=750bca04&scoped=true"
import script from "./UserPositions.vue?vue&type=script&lang=js"
export * from "./UserPositions.vue?vue&type=script&lang=js"
import style0 from "./UserPositions.vue?vue&type=style&index=0&id=750bca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bca04",
  null
  
)

export default component.exports